import React, { useEffect, useContext, useState } from 'react'
import { DesignContext } from 'contexts/DesignContext'
import { useRouteMatch, useLocation } from 'react-router-dom'
import objectPath from 'object-path'
import WidgetLayout from 'designer/component/display/layout/WidgetLayout'
import DisplayVirtLayout from 'designer/component/display/layout/DisplayVirtLayout'
import { useTimeFormat } from 'contexts/TimeFormatContext'

// Action
import { getLocalWidget } from 'designer/component/action/LocalDesign'
import {
  getWidget,
  loadDesignerData,
  resetJsonForm,
  loadApiToFormData,
  loadUrlParamToFormData,
  getWidgetDesign,
  checkFieldConnect,
} from 'designer/component/action/Design'
import FormLoading from 'components/Loader/FormLoading'
import {
  onCheckProviderCondition,
} from 'designer/component/action/condition/Action'
import {
  checkRulesOrCondition,
} from 'designer/component/action/CheckRulesOrCondition'
import { filterDashboardApi } from 'designer/component/filter/dashboard/config/filter'
import { useLockEdit } from 'contexts/PatientLockEditProvider'
import useAuth from 'hooks/useAuth'
import ModalCondition from 'designer/component/component/ModalCondition'
import { mapResponseData } from 'designer/component/action/Api'
import { debounceCallback } from 'utility/debounceCallback.util'

const Widget = (prop) => {
  const {
    designerData = {},
    designerProps,
    onCloseModal,
    uischema,
    isOpenModal,
    widgetData,
    onUpdateData,
    onUpdateFormData,
    designerConfig = {},
    isReset,
    onClearReset,
    searchApi,
    searchData,
    isLocked,
    isInputSearch,
    externalCode,
    externalRevisionId,
    currentWidget,
    comingWidget,
    isSyncWidget,
    setIsSyncWidget,
    uiWidgetKey,
    isGroupValue,
    widgetName,
    isWidgetUpdate,
    employeeList,
    widgetKey,
    dataUpdate,
    isDataUpdate = {},
    setIsDataUpdate,
    isExternalDesign,
  } = prop

  const match = useRouteMatch()
  const location = useLocation()
  const {
    formatDate,
    formatTime,
    formatDateTime,
    dateFormat,
    timeFormat,
  } = useTimeFormat()

  let search = location.search || []
  let pathParams = match.params
  let urlSearchParams = new URLSearchParams(search)
  let queryParams = Object.fromEntries([...urlSearchParams])
  let perspectiveRoute = match.params.perspective || ''
  let queryString = JSON.stringify(queryParams)

  const widgetCode =
    externalCode || widgetData?.formCode || match.params.widgetCode || ''
  const patientLock = useLockEdit()
  const auth = useAuth()
  const { user } = auth
  const designContext = useContext(DesignContext)
  const {
    jsonForm,
    resetContext,
    setComponentPropsData,
    setFormData,
    setIsUpdateDynamic,
    isUpdateDynamic,
    setDatasourceValue,
    setAllFormGroup,
    getEmployee,
    isUiChanged,
    setIsUiChanged,
    setJsonForm,
    widgetDesign,
    setWidgetDesign,
  } = designContext
  let datasourceValue = objectPath.get(designContext, '@datasource') || {}
  let { formData = {}, isVirtualization } = jsonForm || {}

  const componentPropsData = jsonForm?.componentPropsData || {}
  const { data = {}, isClosed, isResponseUpdated } = componentPropsData
  const [isLoadPage, setIsLoadPage] = useState(true)
  const urlParams = { ...pathParams, ...queryParams }
  const refreshWidget = isSyncWidget === uiWidgetKey
  const tempWidget = objectPath.get(isUiChanged, [
    'widgetList',
    widgetKey || externalCode,
  ])
  const oldWidget = objectPath.get(widgetDesign, widgetCode)
  const isLoadWidgetDone = objectPath.get(isUiChanged, [
    'isLoadWidgetDone',
    widgetCode,
  ])
  useEffect(() => {
    return () => {
      objectPath.set(isUiChanged, 'optionsTemp', {})
      setIsUiChanged(isUiChanged)
    }
  }, [widgetCode])

  useEffect(async () => {
    let design
    let jsonForm
    let formData = {}
    if (refreshWidget) {
      design = await getWidgetDesign({
        widgetCode: widgetCode,
        formRevisionId: externalRevisionId,
      })
      if (setIsSyncWidget) {
        setIsSyncWidget(false)
      }
    } else if (tempWidget) {
      jsonForm = tempWidget
    } else if (currentWidget) {
      design = currentWidget
    } else if (comingWidget) {
      design = comingWidget
    } else if (oldWidget) {
      design = oldWidget
    }

    if (!design) {
      if (jsonForm) {
        let { formGroup = [] } = jsonForm
        let designerData = { ...prop.designerData, ...prop.dataUpdate }

        formData = loadDesignerData(
          designerProps,
          { jsonForm, designerData, formData, datasourceValue },
          formGroup,
        )
        formData = loadUrlParamToFormData(
          jsonForm,
          formData,
          pathParams,
          queryParams,
          datasourceValue,
        )
        formData = await loadApiToFormData(jsonForm, formData, {
          urlParams,
          designerData,
          datasourceValue,
        })
        jsonForm.formData = { ...formData, ...designerData }
        if (jsonForm.isVirtualization) {
          jsonForm = await filterDashboardApi(
            {
              ...designContext,
              jsonForm: jsonForm,
              urlParams: urlParams,
              designerData: designerData,
              formatDate,
            },
            null,
            true,
            urlParams,
          )
        }
        jsonForm = checkFieldConnect({
          jsonForm,
          formatDateTime,
          designContext,
          prop,
        })
        setJsonForm(jsonForm)
      }
      setIsLoadPage(false)
      return
    }
    setIsLoadPage(true)
    if (
      objectPath.get(queryParams, 'previewExample') === '1' &&
      localStorage.getItem(widgetCode)
    ) {
      getLocalWidget(widgetCode, perspectiveRoute, resetContext)
    } else {
      let jsonForm = {
        ...design,
        search: searchApi,
      }
      let formGroup = objectPath.get(design, 'jsonForm.formGroup')
      formData = await loadApiToFormData(jsonForm, formData, {
        urlParams,
        designerData,
        datasourceValue,
      })
      formData = loadDesignerData(
        designerProps,
        { jsonForm, designerData, formData, datasourceValue },
        formGroup,
      )
      formData = loadUrlParamToFormData(
        jsonForm,
        formData,
        pathParams,
        queryParams,
        datasourceValue,
      )
      jsonForm.formData = { ...formData, ...designerData }
      if (jsonForm.isVirtualization) {
        jsonForm = await filterDashboardApi(
          {
            ...designContext,
            jsonForm: jsonForm,
            urlParams: urlParams,
            designerData: designerData,
            formatDate,
          },
          null,
          true,
          urlParams,
        )
      }
      jsonForm = checkFieldConnect({
        jsonForm,
        formatDateTime,
        designContext,
        prop,
      })
      resetJsonForm({
        datasourceValue,
        auth,
        user: user,
        designCode: widgetCode,
        formDesign: {
          code: design.formCode,
          name: design.formName,
          formDesignId: design.formDesignId,
        },
        jsonForm: jsonForm,
        perspectiveRoute: perspectiveRoute,
        resetContext: resetContext,
        uischema: jsonForm.uischema,
        schema: jsonForm.schema,
        isSearch: true,
        elementAction: {},
        urlParams: urlParams,
        designerData: designerData,
        datasource: datasourceValue,
        formatDate: formatDate,
        formatTime: formatTime,
        formatDateTime: formatDateTime,
        dateFormat: dateFormat,
        timeFormat: timeFormat,
        isWidget: 1,
        widgetName: widgetName,
        employeeList: employeeList,
      })
    }
    setIsLoadPage(false)
  }, [
    isOpenModal,
    oldWidget,
    widgetCode,
    isSyncWidget === uiWidgetKey,
    isLoadWidgetDone,
  ])

  useEffect(() => {
    if (!widgetData) return
    if (isClosed) {
      setComponentPropsData(componentPropsData)
      onUpdateData(data)
      onCloseModal(componentPropsData)
    }
  }, [isClosed])

  useEffect(() => {
    if (isReset) {
      setFormData({})
    }
    if (onClearReset) {
      onClearReset()
    }
  }, [isReset])

  useEffect(() => {
    if (isUpdateDynamic && onUpdateData) {
      onUpdateData({
        [isUpdateDynamic]: objectPath.get(formData, isUpdateDynamic),
      })
      setIsUpdateDynamic(false)
    }
  }, [isUpdateDynamic])

  useEffect(() => {
    if (isResponseUpdated) {
      objectPath.set(componentPropsData, 'isResponseUpdated', false)
      setComponentPropsData(componentPropsData)
      let data = objectPath.set(componentPropsData, 'data')
      onUpdateFormData(data)
    }
  }, [isResponseUpdated])

  useEffect(() => {
    if (patientLock) {
      onCheckProviderCondition(designContext, {
        Patient: patientLock,
      })
    }
  }, [designContext?.formDesign?.code && patientLock])

  const checkWidget = objectPath.get(isDataUpdate, [widgetName])

  const clearDataUpdate = () => {
    objectPath.set(isDataUpdate, [widgetName], false)
    setIsDataUpdate(isDataUpdate)
  }

  useEffect(() => {
    if (tempWidget && checkWidget) {
      let formGroup = jsonForm.formGroup
      let formData = tempWidget.formData
      formData = loadUrlParamToFormData(
        jsonForm,
        formData,
        pathParams,
        queryParams,
        datasourceValue,
      )
      formData = loadDesignerData(
        designerProps,
        { jsonForm, designerData, formData, datasourceValue },
        formGroup,
      )
      formData = { ...formData, ...designerData }
      objectPath.set(tempWidget, 'formData', formData)
      setJsonForm(tempWidget)
      debounceCallback(clearDataUpdate, [], 'set-is-data-update', 500)
    }
  }, [tempWidget && checkWidget])

  useEffect(() => {
    if (designContext?.formDesign?.code) {
      let formData = objectPath.get(jsonForm, 'formData')
      let apiGroup = jsonForm?.apiGroup || []
      let apiCondition = jsonForm?.apiCondition || []
      let allApi = [...apiGroup, ...apiCondition]
      allApi.map((item) => {
        let data = objectPath.get(formData, `@response.${item.key}`)
        if (data) {
          formData = mapResponseData(item, data, formData, {}, jsonForm)
        }
      })
      objectPath.set(datasourceValue, 'queryParam', queryParams)
      objectPath.set(designContext, '@datasource', datasourceValue)
      objectPath.set(designContext, 'jsonForm.formData', formData)
      setDatasourceValue(datasourceValue)
      setFormData(formData)
      objectPath.set(
        isUiChanged,
        ['widgetList', widgetKey],
        designContext.jsonForm,
      )
      checkRulesOrCondition(designContext, formData, null, {
        designCode: designContext?.formDesign?.code,
        queryString: queryString,
      })
    }
  }, [designContext?.formDesign?.code])

  useEffect(async () => {
    if (isExternalDesign) return
    if (jsonForm.formCode && location.search) {
      let formData = await loadApiToFormData(
        jsonForm,
        {},
        {
          urlParams,
          designerData,
          datasourceValue,
        },
      )
      objectPath.set(isUiChanged, 'isCheckingDesignCode', null)
      objectPath.set(isUiChanged, 'queryParams', queryString)
      setIsUiChanged(isUiChanged)
      setFormData({ ...jsonForm.formData, ...formData })
      checkRulesOrCondition(designContext, formData)
    }
  }, [jsonForm.formCode, location])

  useEffect(async () => {
    if (!isExternalDesign) return
    if (designContext?.formDesign?.code && queryString) {
      datasourceValue = {
        ...datasourceValue,
        pathParam: pathParams,
        queryParam: queryParams,
      }
      let formData = await loadApiToFormData(
        jsonForm,
        {},
        {
          urlParams,
          designerData,
          datasourceValue,
        },
      )
      objectPath.set(isUiChanged, 'isCheckingDesignCode', null)
      objectPath.set(isUiChanged, 'queryParams', queryString)
      setIsUiChanged(isUiChanged)
      setFormData(formData)
      checkRulesOrCondition(designContext, formData)
      setDatasourceValue(datasourceValue)
    }
  }, [designContext?.formDesign?.code && queryString])

  if (isLoadPage) {
    return <FormLoading />
  }

  return (
    <>
      {isVirtualization ? (
        <DisplayVirtLayout />
      ) : (
        <>
          <WidgetLayout
            schema={jsonForm?.schema || {}}
            uischema={jsonForm?.uischema || {}}
            designerConfig={designerConfig}
            onUpdateFormData={onUpdateFormData}
            isInputSearchFromPage={isInputSearch}
            searchDataFromPage={searchData}
            isWidgetUpdate={isWidgetUpdate}
            widgetName={widgetName}
          />
          <ModalCondition />
        </>
      )}
    </>
  )
}

export default Widget
